// MOCK DATA (frontend-only)
// Later this can be replaced with API responses from the backend.

// Serve the CV from the app domain to avoid cross-origin/download issues
export const resumeUrl = "/AmrithPawar_CV.pdf";

export const person = {
  name: "Pawar Amrith",
  location: "Lyon, France",
  email: "amrithpawar150801@gmail.com",
  linkedinLabel: "www.linkedin.com/in/amrithpawar",
  linkedinUrl: "http://www.linkedin.com/in/amrithpawar",
  // Phone is intentionally NOT exposed on the website.
  phone: "",
  portraitUrl: "/profile_3x4.jpg",
};

export const hero = {
  // Keep Surmayee's structure, but adapt content to CV
  line1Prefix: "decoding",
  rotatingWord: {
    initial: "value",
    words: ["value", "risk", "cashflows", "markets"],
  },
  line2Prefix: "defining what's",
  line2Emphasis: "next",
  nextPopup: {
    leftLabel: "Next Internship",
    leftText: "6-month finance internship - starting March 2026",
    rightLabel: "Next Project",
    rightText: "Portfolio simulation & Sharpe-ratio optimization (Python)",
  },
  pinkNoise: {
    label: "Pink Noise",
    gifUrl: "https://surmayee.me/pinknoise.gif",
  },
};

export const about = {
  label: "ABOUT",
  titleLines: [
    { text: "finance.", accent: false },
    { text: "analysis.", accent: true },
  ],
  intro:
    "Master in Management student (Emlyon Business School) with hands-on experience in financial forecasting, variance analysis, and project-level valuation across SME and real-assets contexts. Proven ability to translate financial analysis into management decisions through clear reporting, stakeholder interaction, and data-driven insights.",
  note: "",
  chips: [
    "Budgeting & Forecasting",
    "Variance Analysis",
    "Valuation",
    "Scenario & Sensitivity",
  ],
  portrait: {
    name: "PAWAR AMRITH",
    title: "Master in Management • Finance",
  },
  quote: "",
};

export const pillars = {
  eyebrow: "CORE FINANCIAL SKILLS",
  items: [
    {
      tag: "Modeling",
      title: "Financial Modeling (DCF & Forecasting)",
      detail:
        "Build integrated, driver-based models with clean assumptions and transparent outputs for decision-making and stakeholder alignment.",
      outputs: ["DCF Models", "Forecasts"],
      accent: "rgba(124,140,166,0.85)",
      soft: "rgba(124, 140, 166, 0.18)",
      icon: "calculator",
    },
    {
      tag: "Valuation",
      title: "Valuation (Comps & DCF)",
      detail:
        "Estimate value using comparable companies and discounted cash flow, and communicate key drivers, ranges, and implications with clarity.",
      outputs: ["Comps", "Valuation Ranges"],
      accent: "rgba(124,140,166,0.85)",
      soft: "rgba(124, 140, 166, 0.18)",
      icon: "globe",
    },
    {
      tag: "Statements",
      title: "Financial Statement Analysis (FSA)",
      detail:
        "Analyze P&L, balance sheet, and cash flow to assess profitability, liquidity, leverage, and quality of earnings across periods.",
      outputs: ["Ratios", "KPI Insights"],
      accent: "rgba(124,140,166,0.85)",
      soft: "rgba(124, 140, 166, 0.18)",
      icon: "workflow",
    },
    {
      tag: "Risk",
      title: "Risk & Sensitivity Analysis (Scenarios)",
      detail:
        "Stress-test key assumptions with scenarios and sensitivities to surface breakpoints, downside risks, and decision-ready tradeoffs.",
      outputs: ["Scenarios", "Sensitivity Tables"],
      accent: "rgba(124,140,166,0.85)",
      soft: "rgba(124, 140, 166, 0.18)",
      icon: "sparkles",
    },
  ],
};

export const hobbies = {
  label: "Outside the atelier",
  title: "HOBBIES",
  items: [
    { name: "Chess", detail: "Strategy games and calm calculation." },
    { name: "Billiards", detail: "Angles, patience, and focus." },
    { name: "Skiing", detail: "Focus, balance, and endurance outdoors." },
    { name: "Badminton", detail: "Footwork and quick decisions." },
    { name: "Volleyball", detail: "Coordination and momentum." },
  ],
};

export const extracurriculars = {
  eyebrow: "EXTRACURRICULARS & LEADERSHIP",
  items: [
    {
      title: "La Maison Upcycling — Volunteer",
      organization: "Responsible Commitment Program",
      location: "Lyon (Saint-Priest)",
      period: "18 Feb 2025 – 30 Jun 2025",
      meta: ["50 hours", "Workshops", "Textile upcycling"],
      bullets: [
        "Supported weekly workshops (adults/teens/children/families) and guided participants step-by-step.",
        "Worked on textile upcycling projects, including an Adidas kimono transformation.",
        "Prepared materials, organized tools, ensured safe setup, and helped run recycled games/activities for children.",
      ],
      ctaLabel: "View Report",
      ctaUrl: "/pdfs/la-maison-report.pdf",
    },
    {
      title: "AREMACS — Member/Volunteer",
      organization: "Event waste reduction & sustainability initiatives",
      location: "",
      period: "",
      meta: ["Sustainability", "Events"],
      bullets: [
        "Current member at AREMACS supporting event sustainability operations.",
        "Helped with waste sorting/reduction, on-site awareness, and practical process improvements during events.",
      ],
      ctaLabel: "",
      ctaUrl: "",
    },
    {
      title: "Captain, Institute Kabaddi Team",
      organization: "NIT Rourkela",
      location: "",
      period: "",
      meta: ["Leadership", "Team sport"],
      bullets: [
        "Led team coordination and match preparation with a focus on discipline and consistency.",
        "Supported training structure, match strategy, and accountability across the squad.",
      ],
      ctaLabel: "",
      ctaUrl: "",
    },
  ],
};

export const experienceTimeline = [
  {
    role: "Finance & Strategy Analyst",
    company: "M A Construction Company",
    location: "Sikar, India",
    period: "March 2024 - Aug 2024",
    highlights: [
      "Constructed 12-month revenue and expense forecasts for client portfolios (€8–10M revenue range), achieving ~92% accuracy using trend decomposition, cost-driver mapping, and seasonality patterns.",
      "Analyzed performance gaps across three client portfolios, identifying 500K+ revenue and cost deviations and presenting corrective recommendations to senior management.",
      "Executed internal financial reviews for SME clients, assessing P&L integrity, control effectiveness, and compliance with statutory requirements; delivered management-ready financial summaries and scenario outcomes to inform budgeting, pricing, and investment decisions.",
    ],
  },
  {
    role: "Business Analyst Intern",
    company: "Emeelan Solutions Pvt. Ltd.",
    location: "Bengaluru, India",
    period: "May 2023 - Nov 2023",
    highlights: [
      "Conducted market and competitive analysis across 4+ sectors, synthesizing insights from 10,000+ data points into structured analytical outputs.",
      "Built KPI dashboards tracking pricing, positioning, and growth indicators, reducing reporting turnaround time by ~30%.",
      "Prepared executive-facing presentations translating complex datasets into actionable strategic recommendations for internal stakeholders.",
    ],
  },
  {
    role: "Operations & Finance Associate",
    company: "Family-Owned Retail Business",
    location: "Hyderabad, India",
    period: "Jan 2022 - Jan 2023",
    highlights: [
      "Oversaw budgeting, cost tracking, and working capital monitoring for a family-owned retail operation, gaining hands-on exposure to P&L drivers.",
    ],
  },
];

// Experience narrative (you can refine these skill→implementation mappings anytime)
export const experienceDetails = [
  {
    id: "ma-construction",
    role: "Finance & Strategy Analyst",
    company: "M A Construction Company",
    location: "Sikar, India",
    period: "Mar 2024 - Aug 2024",
    summary:
      "Worked on project-level valuation and forecasting for real estate and infrastructure. Turned costs, timelines, and market assumptions into clear IRR and risk views.",
    impact: [
      "Valued real estate/infrastructure projects (USD 15–20M) with DCF and NAV frameworks.",
      "Built Excel models for residential/commercial projects (USD 5–8M) to support IRR improvement and cost optimization.",
      "Quantified commodity risk (steel/cement/fuel) with scenario & sensitivity analysis.",
    ],
    skillsAcquired: [
      "DCF & NAV valuation",
      "Project cashflow forecasting",
      "Sensitivity & scenario modeling",
      "Cost structure breakdown (materials, labor, CAPEX)",
      "Investment decision storytelling",
    ],
    howIUsedThem: [
      {
        skill: "DCF & NAV valuation",
        applied:
          "Translated construction schedules and milestone payments into cashflow timing, then compared intrinsic value vs land/asset-based value (NAV) to triangulate investment attractiveness.",
      },
      {
        skill: "Sensitivity & scenario modeling",
        applied:
          "Built downside cases for commodity inflation (steel/cement/fuel), mapping margin compression and identifying breakpoints where IRR falls below target.",
      },
      {
        skill: "Excel modeling discipline",
        applied:
          "Structured models with driver tabs, assumptions log, and output pages so non-finance stakeholders could follow logic and trust the result.",
      },
    ],
  },
  {
    id: "emeelan",
    role: "Business Analyst Intern",
    company: "Emeelan Solutions Pvt. Ltd.",
    location: "Bengaluru, India",
    period: "May 2023 - Nov 2023",
    summary:
      "Built research + data workflows to support proposals and management decisions across multiple industry segments.",
    impact: [
      "Researched 5+ industry segments; surfaced opportunities that informed 2 new client proposals.",
      "Analyzed 10,000+ data points and created Excel dashboards & performance reports.",
      "Partnered with tech/sales/strategy to convert requirements into 3 insight deliverables.",
    ],
    skillsAcquired: [
      "Market & competitor research",
      "Dashboarding & KPI design",
      "Data cleaning & analysis",
      "Stakeholder alignment",
      "Structured communication",
    ],
    howIUsedThem: [
      {
        skill: "Market & competitor research",
        applied:
          "Converted raw research into comparable tables (pricing, positioning, feature sets), then highlighted gaps to craft clearer proposal narratives.",
      },
      {
        skill: "Dashboarding & KPI design",
        applied:
          "Designed KPI views that executives could scan quickly. Reduced time-to-insight by keeping metrics consistent and assumptions explicit.",
      },
      {
        skill: "Cross-functional collaboration",
        applied:
          "Translated business questions into analysis tasks that engineering and strategy teams could execute without ambiguity.",
      },
    ],
  },
  {
    id: "family-retail",
    role: "Operations & Finance Associate",
    company: "Family-Owned Retail Business",
    location: "Hyderabad, India",
    period: "Jan 2022 - Jan 2023",
    summary:
      "Ran operational rhythms (inventory, budgeting, P&L) in a high-variance retail context. Learned how small decisions compound.",
    impact: [
      "Tracked basic P&L and cash movement to maintain weekly visibility.",
      "Supported budgeting and inventory planning, improving availability on fast-moving SKUs.",
      "Contributed to local marketing initiatives that helped drive ~25% sales growth.",
    ],
    skillsAcquired: [
      "Practical P&L thinking",
      "Budgeting & forecasting",
      "Inventory planning",
      "Local marketing execution",
      "Operational prioritization",
    ],
    howIUsedThem: [
      {
        skill: "Budgeting & forecasting",
        applied:
          "Forecasted purchases based on sell-through and seasonality, then adjusted reorder frequency to reduce stockouts without overstocking.",
      },
      {
        skill: "Practical P&L thinking",
        applied:
          "Mapped margin by category and used it to focus effort on higher-contribution lines.",
      },
    ],
  },
];

export const education = [
  {
    id: "emlyon-mim",
    school: "Emlyon Business School",
    location: "France",
    period: "Sept 2024 - Present",
    degree: "Master in Management (Programme Grande Ecole)",
    details: [],
    coursework: [
      "Advanced Corporate Finance",
      "Global Capital Markets",
      "Accounting and Control",
      "Financial Diagnosis",
      "Fixed Income: Cashflow and Valuation",
      "Risk Management",
      "Financial Markets",
      "Probabilities for Finance",
      "Financial Macroeconomics",
    ],
  },
  {
    id: "nit-btech",
    school:
      "National Institute of Technology (NIT), Rourkela – Public Institute of National Importance",
    location: "India",
    period: "Aug 2019 - May 2023",
    degree: "Bachelor of Technology in Biotechnology",
    details: [],
    coursework: [
      "Principles of Economics",
      "Biostatistics",
      "Machine Learning",
    ],
  },
  {
    id: "cfa-l1",
    school: "CFA Program",
    location: "",
    period: "May 2026",
    degree: "CFA Level I Candidate",
    details: [],
    coursework: [
      "Ethical and Professional Standards",
      "Quantitative Methods",
      "Economics",
      "Financial Statement Analysis",
      "Corporate Issuers",
      "Equity Investments",
      "Fixed Income",
      "Derivatives",
      "Alternative Investments",
      "Portfolio Management and Wealth Planning",
    ],
  },
];

export const projects = [
  {
    title: "Cowlor — Sustainable Paint Startup (Business Plan)",
    year: "Nov 2024",
    tags: ["Finance", "Business plan", "Startup"],
    pdfUrl: "/pdfs/cowlor-business-plan.pdf",
    pitchDeckUrl: "/pdfs/cowlor-pitch-deck.pdf",
    description:
      "Built the finance section of a startup business plan: unit economics, cost structure, Year 1 financial statements (P&L + Balance Sheet), and projections to support funding decisions.",
    bullets: [
      "Built unit economics and a cost breakdown to support pricing and margin logic.",
      "Prepared Year 1 P&L + Balance Sheet aligned to operating assumptions.",
      "Defined funding assumptions and allocation (total cash €350k; co-founders, bank loan, BPI support).",
      "Extended projections with revenue/expense outlook tables across FY25/FY26 for scale-up planning.",
    ],
    financials: {
      bullets: [
        "Raw materials cost modeled at ~€2.35 per liter (from detailed raw materials table).",
        "Year 1 financial statements built (P&L + Balance Sheet) to validate viability and capital needs.",
        "Startup funding plan captured: €350,000 total cash with mix across co-founders, bank loan, and BPI support.",
        "Revenue/expense outlook tables prepared for FY25/FY26 to support scenario framing.",
      ],
    },
  },
  {
    title: "Python Portfolio Simulation & Sharpe-Ratio Optimization",
    year: "2025",
    tags: ["Python", "pandas", "NumPy"],
    viewUrl:
      "https://drive.google.com/drive/folders/1GJmPvjUv5mYow4iIkqNeEHb3T2GfiVhu?usp=sharing",
    description:
      "Simulated multi-asset portfolios using Python (pandas, NumPy), analyzing return distributions across equities and risk-free assets.",
    bullets: [
      "Computed risk metrics: volatility, Sharpe ratio, drawdowns.",
      "Evaluated portfolio efficiency under varying assumptions.",
      "Summarized results into decision-ready insights and performance comparisons.",
    ],
  },
  {
    title: "Financial Modeling & Scenario Analysis: Air France Case Study",
    year: "2025",
    tags: ["Financial modeling", "Scenario analysis", "Airline drivers"],
    viewUrl:
      "https://drive.google.com/drive/folders/1GJmPvjUv5mYow4iIkqNeEHb3T2GfiVhu?usp=sharing",
    description:
      "Designed an integrated financial model using 3 years of quarterly data, linking capacity (ASK), load factor, yield, and unit revenue.",
    bullets: [
      "Modeled revenue drivers, cost structure, and operating leverage.",
      "Performed sensitivity analysis on capacity, yield, and load-factor assumptions.",
      "Synthesized conclusions on revenue quality, profitability drivers, and downside risk exposure.",
    ],
  },
];

export const projectPortfolioUrl =
  "https://drive.google.com/drive/folders/1GJmPvjUv5mYow4iIkqNeEHb3T2GfiVhu?usp=sharing";

export const blogPosts = [
  {
    slug: "from-bio-to-balance-sheets",
    title: "From biotech to balance sheets",
    excerpt:
      "How I moved from scientific thinking to finance. Keeping the discipline, upgrading the toolkit.",
    date: "2025-06-01",
    readTime: "4 min",
    body: [
      "Biotech trained me to respect data, uncertainty, and long feedback loops.",
      "Finance adds speed: decisions often happen before perfect information exists.",
      "I now build models that are both rigorous and usable, so teams can act with confidence.",
    ],
  },
  {
    slug: "models-that-earn-trust",
    title: "Models that earn trust",
    excerpt:
      "A short checklist I use to keep assumptions honest and outputs decision-ready.",
    date: "2025-05-12",
    readTime: "5 min",
    body: [
      "Start with the question: what decision will this model support?",
      "Keep inputs explicit, drivers named, and sensitivity ready.",
      "Design the last mile: charts, ranges, and caveats.",
    ],
  },
];
